import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { MonthlyView } from './components/MonthlyView';
import { DailyView } from './components/DailyView';
import { GetKPIs } from './components/GetKPIs';
import { HourlyView } from './components/HourlyView';
import { MonthlySummary } from './components/MonthlySummary';
import { About } from './components/About';
import { CommentView } from './components/CommentView';
import { EngineeringDetails } from './components/EngineeringDetails';
import { WeeklyView } from './components/WeeklyView';
export default class App extends Component {
    displayName = App.name
    render() {
        return (
            <Layout>
                <Route exact path='/' component={DailyView} />
                <Route path='/HourlyView' component={HourlyView} />
                <Route path='/DailyView' component={DailyView} />
                <Route path='/WeeklyView' component={WeeklyView} />
                <Route path='/MonthlyView' component={MonthlyView} />
                <Route path='/GetKPIs' component={GetKPIs} />
                <Route path='/MonthlySummary' component={MonthlySummary} />
                <Route path='/CommentView' component={CommentView} />
                <Route path='/EngineeringDetails' component={EngineeringDetails} />
                <Route path='/About' component={About} />
            </Layout>

        );
    }
}

